<template>
  <validation-observer
    v-if="isPropertyYearsLivedShown"
    v-slot="propertyYearsLivedObserver"
    slim
  >
    <form-section
      id="property-years-lived"
      v-bind="propertyYearsLivedObserver"
      :validated="formObserver.validated"
    >
      <form-row
        label="How many years have you lived here?"
      >
        <validation-provider
          v-slot="{ errors, failed }"
          name="Property Years Lived"
          :vid="`${stepId}_property-years-lived`"
          :rules="{ propertyYearsLived:
            { maxYears: propertyYearsLivedMax }
          }"
          slim
        >
          <qz-number-input
            v-model.number="questionData.propertyYearsLived"
            :error="failed"
            :error-messages="errors"
            :data-test="`${stepId}_property-years-lived`"
            placeholder="e.g. 5"
            :maxlength="inputCharsLimiters.YEARS_LIVED"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from '@/components/questions/Base';

import {
  UtcDate,
} from '@/helpers/date';

export default {
  name: 'question-property-years-lived',
  extends: QuestionBase,
  data () {
    return {
      fields: ['propertyYearsLived'],
    };
  },
  computed: {
    isCoverContentsOnly () {
      return this.formData.home.propertyCoverType === 'C';
    },

    isPropertyOwned () {
      return this.formData.home.propertyOwned === 'YM' || this.formData.home.propertyOwned === 'YO';
    },

    propertyNotPurchased () {
      return !this.helpers.isNull(this.stepData.propertyPurchased) && this.stepData.propertyPurchased === 'N';
    },

    propertyYearsLivedMax () {
      return new UtcDate().getFullYear() - this.formData.home.propertyYear;
    },

    isPropertyYearsLivedShown () {
      // hidden if propertyPurchased is set to 'N' but must be shown if property type - renting or if contents cover only
      if (!this.isPropertyOwned || this.isCoverContentsOnly) {
        return true;
      }

      return !this.propertyNotPurchased;
    },
  },
};
</script>
